import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigator} from '~/common/FabricInvitation/EventCreateDesign/components/NavBottom/hooks/useNavigator';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {useUyo} from '~/common/fabric/Card/hooks/useUyo';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';

export const useDesignValidation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigator({});
  const {isUyo, pristineUyo, isFilledUyo, isLogoFilled} = useUyo();

  // Handle UYO effect
  useEffect(() => {
    if (isUyo) {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {
          activeCardEditor: isFilledUyo || isLogoFilled ? 'image' : 'intro',
        },
      });
      navigate(Sections.UPLOAD_PHOTO);
    }
  }, [dispatch, isFilledUyo, isLogoFilled, isUyo, navigate]);

  // Standard navigation effect for design page
  useEffect(() => {
    const portal = document.getElementById('pbModalRoot');
    if (portal) {
      portal.style.position = 'unset';
    }
    navigate(Sections.UPLOAD_PHOTO);
  }, [navigate]);

  return {
    isUyo,
    pristineUyo,
    isFilledUyo,
  };
};
